export default __webpack_public_path__ + "static/124-min-min-3359e9f85dd85cd6e4d31413bfe8baeb.jpg";